<template>
    <div class="mobile-wallets-checkout py-1">
        <div class="strong-text--text medium-text text-center mb-4">
            قم بتحويل مبلغ <strong>{{moneyFormat(amount)}} جنيه</strong> إلى الرقم التالي:
        </div>
        <div class="pa-2 rounded error--text font-weight-bold text-center" style="border: 2px solid; font-size: 20px; letter-spacing: 1px!important;">
            {{mobileWalletNumber}}
        </div>
        <v-divider class="my-5"></v-divider>
        <div class="text-center strong-text--text mb-3">
            انتظر رسالة تأكيد العملية، ثم املأ الحقول التالية بدقة لنتمكن من مراجعة العملية وتأكيدها:
        </div>
        <div class="payment-timing-note mb-4">
            بعد إرسال الطلب لازم تتم مراجعة العملية من فريق الدعم. العملية بتاخد من دقايق حتى 12 ساعة بحد أقصى. مواعيد عمل الفريق: من 10 صباحًا حتى 1 ليلًا.
        </div>
        <v-form ref="form">
            <v-text-field v-model="payerNumber" outlined color="error" placeholder="رقم محفظة الجوال الخاصة بك" persistent-hint hint="رقم محفظة الجوال التي أرسلت منها (مثال: رقم فودافون كاش الخاص بك)" prepend-inner-icon="mdi-cellphone" class="mb-2" :disabled="loading" :rules="[rules.required]"></v-text-field>
            <v-file-input v-model="attachment" accept="image/*" outlined color="error" placeholder="أرفق صورة رسالة التأكيد" prepend-icon="" prepend-inner-icon="mdi-attachment" persistent-hint hint="قم بإرفاق لقطة شاشة لرسالة تأكيد العملية التي وصلتك من فودافون كاش أو المحفظة التي أرسلت منها، أو أرفق إيصال لتأكيد العملية." :disabled="loading" :rules="[rules.required]"></v-file-input>
            <v-expand-transition mode="out-in">
                <div v-if="!leaveMessage" key="0">
                    <v-btn text class="mt-2" block @click="leaveMessage = true">
                        <v-icon left>mdi-message-text-outline</v-icon>
                        اضغط هنا لتترك لنا رسالة مع العملية
                    </v-btn>
                </div>
                <div v-else key="1">
                    <v-textarea v-model="message" color="grey lighten-1" outlined no-resize hide-details placeholder="اترك لنا رسالة (اختياري)" rows="3" class="mt-4">

                    </v-textarea>
                </div>
            </v-expand-transition>
        </v-form>

        <div class="w-100 mt-5">
            <v-btn block :disabled="loading" :loading="loading" depressed color="error" large @click="submit">
                <v-icon size="24" left>mdi-cash-check</v-icon>
                <strong>إتمام الدفع</strong>
            </v-btn>
        </div>
    </div>
</template>

<script>
import GlobalComputed from '@/helpers/global-computed'
import GlobalMethods from '@/helpers/global-methods'

export default {
    props: {
        amount: {
            required: true,
        }
    },
    data(){
        return {
            loading: false,
            payerNumber: '',
            attachment: null,
            message: '',

            leaveMessage: false,

            rules: {
                required: value => !!value || 'لا يمكنك ترك الحقل فارغاً'
            },
        }
    },
    computed: {
        ...GlobalComputed,
        appRechargeInfo(){
            return this.appData ? this.appData.recharge_info : {};
        },
        mobileWalletNumber(){
            return this.appRechargeInfo ? this.appRechargeInfo.mobile_wallet_number : '___';
        }
    },
    methods: {
        ...GlobalMethods,
        submit(){
            if (!this.loading){
                if (this.$refs.form.validate()){
                    this.loading = true;
                    let data = new FormData();
                    data.append('amount', this.amount);
                    data.append('payer_number', this.payerNumber);
                    data.append('attachment', this.attachment);

                    if (this.message){
                        data.message = this.message;
                        data.append('message', this.message);
                    }
                    this.$store.dispatch('rechargeByMobileWallets', data).then(response=>{
                        this.loading = false;
                        this.showMsg('شكراً لك، تم إرسال العملية بنجاح، سنقوم بمراجعة العملية أولاً ثم إضافة الرصيد لحسابك بأسرع وقت.', 'success')

                        window.setTimeout(()=>{
                            this.payerNumber = '';
                            this.amount = '';
                            this.attachment = '';
                            this.message = '';
                        }, 500);

                        this.$emit('done');

                    }).catch(e=>{
                        this.loading = false;
                        let msg = e && e.response && e.response.data ? e && e.response.data : null;
                        if (msg){
                            if (msg === 'LESS_THAN_MIN_AMOUNT'){
                                this.showMsg('المبلغ الذي أدخلته أقل من الحد اﻷدنى للشحن', 'error');
                            }else{
                                this.showMsg('حدثت مشكلة أثناء تنفيذ الإجراء، عاود إرسال الطلب', 'error');
                            }
                        }else{
                            this.showMsg('حدثت مشكلة أثناء تنفيذ الإجراء، عاود إرسال الطلب', 'error');
                        }

                    })
                }else{
                    this.showMsg('من فضلك املأ الحقول المطلوبة', 'warning');
                }
            }
        }
    },
    mounted(){
        
    }
}
</script>

<style lang="scss">
.mobile-wallets-checkout{
    .v-messages{
        min-height: 18px!important;
    }
}

.payment-timing-note{
    padding: 10px 12px;
    border-radius: 10px;
    background: rgba(15, 23, 42, 0.04);
    color: rgba(15, 23, 42, 0.7);
    font-size: 0.8rem;
    font-weight: 600;
    line-height: 1.65;
    text-align: center;
}
</style>